import {getFileIcon} from "../../../utils/file";
import {Loading, UploadedItem} from "../../index";
import React, {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import i18nNamespaces from "../../../const/i18nNamespaces";
import {useAppSelector} from "../../../hooks/customReduxHooks";
import {selectMedicalRecord} from "../../../store/medicalRecordSlice";
import filesDownloadProvider from "../../../services/filesDownloadProvider";
import {medicalRecordsApi} from "../../../api/medicalRecords/medicalRecordsApi";
import {Box, IconButton} from "@material-ui/core";
import {GetApp} from "@material-ui/icons";


const MedicalRecordFile = () => {
    const {t, i18n} = useTranslation(i18nNamespaces.MEDICAL_RECORD);
    const medicalRecord = useAppSelector(selectMedicalRecord);
    const [loading, setLoading] = useState(false);

    const medicalRecordFilename = useMemo(() =>
        t('medicalRecord') + "_" + medicalRecord.creationDateTime.toFormat("dd_MM_yyyy_HH_mm") + ".pdf",
        [medicalRecord, t]);

    const handleClickDownload = async (
    ) => {
        try {
            setLoading(true);
            const {data: url} = await medicalRecordsApi.getMedicalRecordPdfUrl(
                medicalRecord.id
            );
            filesDownloadProvider.downloadFileFromUrl(
                url,
                medicalRecordFilename
            );
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <Loading withBackdrop loading={loading} />
            <Box onClick={handleClickDownload} style={{cursor: 'pointer', display: 'flex', justifyContent: 'space-between'}}>
                <UploadedItem
                    fileName={
                        medicalRecordFilename
                    }
                    fileOwner={
                        ""
                    }
                    fileIcon={getFileIcon('application/pdf')}
                    fileDateCreated={medicalRecord.creationDateTime.toFormat(
                        "dd'.'MM'.'yyyy",
                    )}
                    fileTimeCreated={medicalRecord.creationDateTime.toFormat(
                        "HH':'mm",
                    )}
                    removeFileEnabled={false}
                />
                <Box style={{display: 'flex', alignItems: 'center'}}>
                    <IconButton onClick={handleClickDownload} size={'small'}>
                        <GetApp color={'secondary'} fontSize={'small'}/>
                    </IconButton>
                </Box>
            </Box>
        </>
    )
}

export default MedicalRecordFile;
